import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { EntityV2Store, configStore } from "../../state/CommonState";
import EntityV2Api from "../../state/entities-api";
import { loader } from "../../util/loader";
import Newapi from "../../state/new-api";
import { ServerLists } from "../../StaticData"

console.log("Rendering Customer Portfolio", EntityV2Store.EntityRec);
const businessFields = [
  {
    name: "natureOfBusiness",
    label: "Nature of Business",
    type: "select",
    options: ["Manufacturer", "Trader"],
  },
  {
    name: "natureOfCargo",
    label: "Nature of Cargo",
    type: "select",
    options: [
      "Equipment",
      "General Cargo",
      "Perishables",
      "Hazardous",
      "Textiles",
    ],
  },
  {
    name: "turnover",
    label: "Turnover",
    type: "currency",
    currencies: ["INR", "USD", "EUR"],
  },
  {
    name: "customerStatus",
    label: "Customer Status",
    type: "select",
    options: [
      "Prospect",
      "Lead",
      "Active",
      "Inactive",
      "Preferred",
      "Blacklisted",
    ],
  },
];

const questions = [
  {
    id: 1,
    name: "cargoType",
    question:"What type of cargo do you typically ship — general cargo, hazardous goods, perishables, or oversized freight — and what are your primary trade lanes (origin & destination countries)?",
  },
  {
    id: 2,
    name: "shipmentVolume",
    question: "What is your average monthly or annual shipment volume, and how does it fluctuate seasonally?",
  },
  {
    id: 3,
    name: "transportMode",
    question: "Do you currently move cargo by sea (FCL/LCL), air, or multimodal, and what percentage splits across each mode?",
  },
  {
    id: 4,
    name: "freightPartner",
    question: "Who is your current freight forwarder or logistics partner, and what is the one thing you wish they did better?",
  },
  {
    id: 5,
    name: "shipmentTracking",
    question: "How do you currently track your shipments and get visibility into your supply chain — do you use a TMS, ERP, or rely on forwarder updates?",
  },
  {
    id: 6,
    name: "delaysAndCompliance",
    question: "How often do you face delays, documentation errors, or compliance issues — and what is the business impact when that happens?",
  },
  {
    id: 7,
    name: "decisionMakers",
    question: "Who else is involved in selecting or approving a freight forwarding partner — is the decision made by procurement, supply chain, or the finance team?",
  },
  {
    id: 8,
    name: "procurementProcess",
    question: "What does your typical procurement process look like — do you work on spot rates, annual contracts, or rate cards, and how frequently do you go to market?",
  },
  {
    id: 9,
    name: "majorChallenge",
    question: "If you could solve one major challenge in your international logistics in the next 6 months, what would it be?",
  },
];

const shipmentTypesForPort = ["LCL", "FCL", "AIR", "FBA"];

const shipmentTypes = [
  {
    type: "LCL",
    unit: "CBM",
  },
  {
    type: "FCL",
    unit: "TEU",
  },
  {
    type: "AIR",
    unit: "Chargeable Wt KG",
  },
  {
    type: "FBA",
    unit: "CBM",
  },
];

const activityDatalabel = [
  {
    label: "Last Enquiry Date",
    value: "latestEnquries",
  },
  {
    label: "Last Rate Quoted Date",
    value: "latestQuotes",
  },
  {
    label: "Last Booking Date",
    value: "latestBooking",
  },
  {
    label: "Last Meeting Date",
    value: "latestMeeting",
  },
];

export default function CustomerPortfolio({activeTab, fn}) {
  const [openAccordion, setOpenAccordion] = useState(false);
  const [fbaAddressList, setPortOptions] = useState([]);
  const [activityData, setActivityData] = useState(null);
  const { watch, setValue, control, register, reset, handleSubmit } = useForm({
    defaultValues: {
      entityId: EntityV2Store.EntityRec.entityId,
      _id: "",
      natureOfBusiness: "",
      natureOfCargo: "",
      turnoverCurrency: "INR",
      turnoverAmount: "",
      customerStatus: "",
      selectedShipmentTypes: [],
      basePort: {
        LCL: [],
        FCL: [],
        AIR: [],
        FBA: [],
      },
    },
  });

  let addresslist = [{ value: "All Countries", label: "All Countries" },
    ...ServerLists.countryNameList.filter((address) => address)
  .map((address) => ({ value: address, label: address }))]
  
  useEffect(() => {
    
    const getCustomerPortfolio = () => {
      try {
        const callback = (data) => {
          if(data){
            if(data._id){
              reset(data)
            }
            setActivityData(data.latestData);
            loader.hide();
          }
        };
        EntityV2Api.getCustomerPortfolio(EntityV2Store.EntityRec.entityId, callback)
      } catch (error) {
        configStore.setModalMessage(error.message);
        console.error("Error fetching customer portfolio: ", error);
      }
    };
    loader.show();
    getCustomerPortfolio();
  }, [reset]);

  const fetchPorts = async (inputValue, type) => {
  try {
    let keyword = encodeURI(inputValue)
    let url = `${process.env.REACT_APP_API_SERVER}/api/v1/location/fetchaddressfba/${keyword}?warehouse=${'ALL'}`
    const result = await Newapi.get(url);
    const formattedData = result.map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setPortOptions((prev) => {
      const merged = [...prev, ...formattedData];

      return merged.filter(
        (item, index, self) =>
          index === self.findIndex((x) => x.value === item.value)
      );
    });

  } catch (error) {
    console.log(error);
  }
};

  const handlePortSearch = (inputValue, type) => {
    if (inputValue.length >= 3) {
      fetchPorts(inputValue, type);
    }
    return inputValue;
  };


  const onSubmit = (data) => {
    loader.show();
    const callback = (d) => {
      loader.hide();
      configStore.setModalMessage(`submitted successfully.`,[],false);
    };
    EntityV2Api.AddCustomerPortfolio(data, callback)
    console.log(" Form Data: ", data);
  };

  const selectedShipmentTypes = watch('selectedShipmentTypes') || [];
  const basePort = watch("basePort") || {};

  const handlePortToggle = (type) => {
    if (selectedShipmentTypes.includes(type)) {
      setValue(
        "selectedShipmentTypes",
        selectedShipmentTypes.filter((item) => item !== type)
      );
      setValue(`basePort.${type}`, []);
    } else {
      setValue("selectedShipmentTypes", [...selectedShipmentTypes, type]);
    }
  };

  const handleRemoveAddress = (type, address) => {
    const updated = (watch(`basePort.${type}`) || []).filter(
      (item) => item.address !== address
    );
    setValue(`basePort.${type}`, updated);
  };


  const formatDate = (timestamp) => {
    if (!timestamp) return "N/A";
    return new Date(Number(timestamp)).toLocaleDateString("en-GB");
  };
  
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="bg-[#F3F4FD] rounded-2xl p-4 sm:p-5 mb-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <div className="w-full">
          <h2 className="text-[#2434A1] text-lg sm:text-xl font-semibold mb-2">
            Activity Dates
          </h2>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs sm:text-sm text-[#2B2B2B]">
            {activityData !== null && activityDatalabel.map((item, index) => (
              <React.Fragment key={index+1}>

                <div className="flex items-center gap-1.5">
                  <span className="text-[#4A4A4A]">
                    {activityDatalabel[index].label} :
                  </span>
                  <span className="font-medium text-[#1e293b]">
                    {formatDate(activityData[activityDatalabel[index].value])}
                  </span>
                </div>

                {index !== activityDatalabel.length - 1 && (
                  <div className="text-[#9A9A9A] hidden sm:inline">|</div>
                )}

              </React.Fragment>
            ))}
          </div>
        </div>
        <div className="flex items-center gap-2 text-[#F28C28] font-medium text-xs sm:text-sm self-start md:self-auto bg-white/70 px-3 py-1.5 rounded-lg border border-[#F28C28]/20 flex-shrink-0">
          <span className="w-2 h-2 rounded-full bg-[#F28C28]"></span>
          <span>{activityData?.latestMeetingType == null ? "No Recent Activity" : activityData.latestMeetingType }</span>
        </div>
      </div>
      <div className="px-2 sm:px-5 space-y-6 sm:space-y-8 w-full lg:w-[90%] xl:w-[85%]">
        <div className="mx-auto pb-5" style={{ borderBottom: "1px solid #E6E6E6" }}>
          <h2 className="text-lg sm:text-xl font-semibold mb-3">
            Business Details
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 sm:gap-x-16 gap-y-5 sm:gap-y-6">
            {businessFields.map((field) => {
              if (field.type === "select") {
                return (
                  <div key={field.name}>
                    <label className="block mb-2 text-[#2B3688] font-medium">
                      {field.label}
                    </label>

                    <select
                      {...register(field.name)}
                      className="w-full border border-[#DDDDDD] outline-none
                      focus:border-[#DDDDDD] focus:ring-0 focus-visible:border-[#DDDDDD] rounded px-3 py-2"
                    >
                      <option value="">Select...</option>

                      {field.options.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                );
              }

              if (field.type === "currency") {
                return (
                  <div key={field.name}>
                    <label className="block mb-2 text-[#2B3688] font-medium ">
                      {field.label}
                    </label>

                    <div className="flex gap-2">
                      <select
                        {...register("turnoverCurrency")}
                        className="w-24 border border-[#DDDDDD] outline-none
                        focus:border-[#DDDDDD] focus:ring-0 focus-visible:border-[#DDDDDD] rounded px-3 py-2"
                      >
                        {field.currencies.map((currency) => (
                          <option key={currency}>{currency}</option>
                        ))}
                      </select>

                      <input
                        type="number"
                        placeholder="Enter amount"
                        {...register("turnoverAmount")}
                        className="flex-1 border border-solid border-[#DDDDDD] outline-none
                        focus:border-[#DDDDDD] focus:ring-0 focus-visible:border-[#DDDDDD] rounded px-3 py-2"
                      />
                    </div>
                  </div>
                );
              }

              return null;
            })}
          </div>
        </div>
        <div style={{ borderBottom: "1px solid #E6E6E6" }}>
          <div className="border border-solid border-[#D2D2D2] rounded-xl overflow-hidden mt-5 mb-5 px-3 py-2" >
            <div
              onClick={() => setOpenAccordion(!openAccordion)}
              className="flex items-center justify-between p-2 bg-white cursor-pointer border-b"
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-[#E6E9FF] flex items-center justify-center">
                  💬
                </div>

                <div className="flex items-center gap-3">
                  <h2 className="text-lg font-semibold">
                    Discover Questions
                  </h2>

                  <span className="hidden sm:block bg-[#E6E9FF] text-[#2B3688] text-sm px-3 py-1 rounded-full">
                    {questions.length} Questions
                  </span>
                </div>
              </div>

              {/* Arrow */}
              <div className="text-xl">
                {openAccordion ? "⌃" : "⌄"}
              </div>
            </div>
            {openAccordion && (
              <>
              {questions.map((item) => (
                <div key={item.id}>
                  <label className="block mb-3 text-gray-800 font-medium">
                    {item.question}
                  </label>

                  <textarea
                    rows={3}
                    placeholder="Enter Response..."
                    className="w-full border border-[#EAEAEA] p-4 outline-none focus:ring-2 focus:ring-indigo-400"
                    {...register(item.name)}
                  />
                </div>
              ))}
              </>
            )}
          </div>
        </div>
      </div>
 
      <div className="max-w-6xl px-3 sm:px-5 bg-white sm:bg-transparent border border-gray-200 rounded-2xl mt-4 pb-5 w-full lg:w-[90%] xl:w-[85%]">
        {/* Mobile View - Product Interests Buttons */}
        <div className="block md:hidden space-y-3 pt-2 mb-4">
          <label className="text-sm font-medium text-[#3b4175] block">
            Product Interests <span className="text-red-500">*</span>
          </label>
          <div className="flex flex-wrap gap-1">
            {shipmentTypesForPort.map((item) => {
            console.log("shipmentTypesForPort", shipmentTypesForPort)
            const isSelectedShipment = selectedShipmentTypes.includes(item);
            return (
              <button
                type="button"
                key={item}
                onClick={() => handlePortToggle(item)}
                className={`
                  px-5 py-2 rounded-full text-sm font-medium transition-all
                  ${
                    isSelectedShipment
                      ? "bg-[#E7E9FF] border-none text-[#2434A1]" 
                      : "bg-white border border-solid border-[#E1E1E1] text-[#222]"
                  }
                `}
              >
                {item}
              </button>
            );
          })}
          </div>
        </div>

        {/* Desktop View - Product Interests Buttons */}
        <div className="hidden md:block">
          <h2 className="text-[#2434A1] text-[18px] font-medium mb-2">
            Product Interests
          </h2>
          <div className="flex flex-wrap gap-3 mb-2">
            {shipmentTypesForPort.map((item) => {
              const isSelectedShipment = selectedShipmentTypes.includes(item);
              return (
                <button
                  type="button"
                  key={item}
                  onClick={() => handlePortToggle(item)}
                  className={`
                    px-5 py-2 rounded-full text-sm font-medium transition-all
                    ${
                      isSelectedShipment
                        ? "bg-[#E7E9FF] border-none text-[#2434A1]" 
                        : "bg-white border border-solid border-[#E1E1E1] text-[#222]"
                    }
                  `}
                >
                  {item}
                </button>
              );
            })}
          </div>
        </div>

        {/* Mobile View - Dynamic Ports Fields (Product Interests Containers) */}
        <div className="block md:hidden space-y-6 mt-4">
          {selectedShipmentTypes.map((type) => {
            const typeInfo = shipmentTypes?.find((s) => s.type === type);
            const unitOption = watch(`units.${type}`) || (typeInfo ? typeInfo.unit : "Unit");
            const addressList = watch(`basePort.${type}`) || [];

            return (
              <div key={type} className="flex flex-col w-full bg-white gap-4">
                <div className="flex items-center gap-1.5 text-black font-semibold text-base">
                  <span>{type}</span>
                  <span className="text-xs text-gray-500 font-normal">
                    (Volumes Captured in {unitOption})
                  </span>
                </div>

                <div className="text-[#3b4175] w-full">
                  <label className="block text-[#2B3688] mb-1.5 text-sm font-medium">
                    {type === "FBA" ? "Trade Lanes / Sectors" : "Trade Lanes / Sectors / Countries"}
                  </label>
                  <Controller
                    name={`basePort.${type}`}
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        isMulti
                        hideSelectedOptions={false}
                        controlShouldRenderValue={false}
                        options={type === "FBA" ? fbaAddressList : addresslist}
                        placeholder="Select Trade Lanes.."
                        classNamePrefix="react-select"
                        onInputChange={(inputValue) => {
                          if (type !== "FBA") return;
                          handlePortSearch(inputValue);
                        }}
                        onChange={(selected) => {
                          let updatedSelection = selected || [];
                          const hasAllCountries = updatedSelection.some(
                            (item) => item.value === "All Countries"
                          );

                          if (hasAllCountries) {
                            const lastSelected = updatedSelection[updatedSelection.length - 1];

                            if (lastSelected.value === "All Countries") {
                              updatedSelection = [lastSelected];
                            } else {
                              updatedSelection = updatedSelection.filter(
                                (item) => item.value !== "All Countries"
                              );
                            }
                          }
                          const existing = field.value || [];
                          const updated = updatedSelection.map((address) => {
                            const old = existing.find(
                              (item) => item.address === address.value
                            );

                            return {
                              address: address.value,
                              volume: old?.volume || "",
                            };
                          });

                          field.onChange(updated);
                        }}
                        value={(type === "FBA" ? fbaAddressList : addresslist).filter((option) =>
                          (field.value || []).some(
                            (x) => x.address === option.value
                          )
                        )}
                        styles={{
                          control: (base) => ({
                            ...base,
                            width: "100%",
                            minHeight: "42px",
                            borderColor: "#DDDDDD",
                            borderRadius: "0.5rem",
                            boxShadow: "none",
                            "&:hover": {
                              borderColor: "#2B3688",
                            },
                          }),
                          menu: (base) => ({
                            ...base,
                            width: "100%",
                            zIndex: 30,
                          }),
                          placeholder: (base) => ({
                            ...base,
                            color: "#999",
                            fontSize: "13px",
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#EEF2FF"
                              : state.isFocused
                              ? "#F5F5F5"
                              : "#fff",
                            color: "#222",
                            fontSize: "13px",
                          }),
                        }}
                      />
                    )}
                  />
                </div>

                {/* Country / Sector volume boxes */}
                {addressList.length > 0 && (
                  <div className="flex flex-col gap-3">
                    {addressList.map((item, index) => (
                      <div
                        key={`${item.address}-${index}`}
                        className="relative bg-[#F3F4FD] border border-[#e0e3ff] rounded-xl p-4 flex flex-col gap-2"
                      >
                        <button
                          type="button"
                          onClick={() => handleRemoveAddress(type, item.address)}
                          className="absolute top-3.5 border-0 bg-transparent right-3.5 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>

                        <div className="text-sm font-semibold text-slate-800 pr-6">
                          {item.address}
                        </div>

                        <div className="space-y-1 w-full">
                          <label className="text-xs font-semibold text-slate-500 block">
                            Volume ({unitOption})
                          </label>
                          <input
                            className="h-[38px] bg-white border-solid border-slate-200 focus-visible:ring-1 focus-visible:ring-[#2B3688] outline-none rounded-lg px-3 text-sm w-full"
                            placeholder="0"
                            type="number"
                            value={item.volume || ""}
                            onChange={(e) => {
                              const updated = [...(watch(`basePort.${type}`) || [])];
                              updated[index] = {
                                ...updated[index],
                                volume: e.target.value,
                              };
                              setValue(`basePort.${type}`, updated);
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Desktop View - Dynamic Ports Fields */}
        <div className="hidden md:grid md:grid-cols-1 gap-x-12 gap-y-4">
          {shipmentTypesForPort
            .filter((item) => selectedShipmentTypes.includes(item))
            .map((item) => {
              const unit = shipmentTypes.find((shipment) => shipment.type === item)?.unit || "";
              return (
                <div key={item} className="mb-6">
                  <label className="block text-[#000000] mb-2 font-medium">
                    {item} <span className="text-xs text-[#535671]">(Volumes Captured in {unit})</span>
                  </label>
                  <label className="block text-[#2B3688] mb-2 font-medium">
                    Trade Lanes / Sectors / Countries
                  </label>
                  <Controller
                    name={`basePort.${item}`}
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        isMulti
                        hideSelectedOptions={false}
                        controlShouldRenderValue={false}
                        options={item === "FBA" ? fbaAddressList : addresslist}
                        placeholder={ "Search Trade Lanes / Sectors / Countries..." }
                        classNamePrefix="react-select"
                        onInputChange={(inputValue) => {
                          if (item !== "FBA") return;
                          handlePortSearch(inputValue);
                        }}
                        onChange={(selected) => {
                          let updatedSelection = selected || [];
                          const hasAllCountries = updatedSelection.some(
                            (item) => item.value === "All Countries"
                          );

                          if (hasAllCountries) {
                            const lastSelected = updatedSelection[updatedSelection.length - 1];

                            if (lastSelected.value === "All Countries") {
                              updatedSelection = [lastSelected];
                            } else {
                              updatedSelection = updatedSelection.filter(
                                (item) => item.value !== "All Countries"
                              );
                            }
                          }
                          const existing = field.value || [];
                          const updated = updatedSelection.map((address) => {
                            const old = existing.find(
                              (item) => item.address === address.value
                            );

                            return {
                              address: address.value,
                              volume: old?.volume || "",
                            };
                          });

                          field.onChange(updated);
                        }}
                        value={(item === "FBA" ? fbaAddressList : addresslist).filter((option) =>
                          (field.value || []).some(
                            (x) => x.address === option.value
                          )
                        )}
                        styles={{
                          control: (base) => ({
                            ...base,
                            width: '44%',
                            minHeight: "42px",
                            borderColor: "#DDDDDD",
                            boxShadow: "none",
                            "&:hover": {
                              borderColor: "#876c6c",
                            },
                          }),
                          menu: (base) => ({
                            ...base,
                          width: '44%',
                          }),

                          placeholder: (base) => ({
                            ...base,
                            color: "#999",
                            fontSize: "12px",
                          }),

                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#fff"
                              : state.isFocused
                              ? "#F5F5F5"
                              : "#fff",

                            color: "#222",

                            ":active": {
                              backgroundColor: "#F5F5F5",
                            },
                          }),
                        }}
                      />
                    )}
                  />
                  <div className="w-full mt-3 overflow-x-auto">
                    <table className="w-full border border-gray-200 rounded-lg">
                      {basePort[item]?.length > 0 && <thead className="bg-[#F4F5FF] text-[#2B3688] text-sm">
                        <tr>
                          <th className="px-4 py-3 w-1/3">
                            Country / Region
                          </th>

                          <th className="px-4 py-3 w-1/3">
                            Volume ({unit})
                          </th>

                          <th className="!text-center px-4 py-3 w-1/3">
                            Action
                          </th>
                        </tr>
                      </thead>}
                      <tbody>
                        {(watch(`basePort.${item}`) || []).map((port, index) => (
                          <tr
                            key={port.address}
                            style={{ borderBottom: "1px solid #E6E6E6" }}
                          >
                            <td className="px-4 py-3 text-center font-medium text-gray-800">
                              {port.address}
                            </td>
                            <td className="px-4 py-3">
                              <div>
                                <input
                                  type="number"
                                  value={port.volume}
                                  placeholder="0"
                                  onChange={(e) => {
                                    const updated = [...watch(`basePort.${item}`)];

                                    updated[index] = {
                                      ...updated[index],
                                      volume: e.target.value,
                                    };

                                    setValue(`basePort.${item}`, updated);
                                  }}
                                  className="w-56 max-w-xs border-solid rounded-lg px-3 py-2"
                                />
                              </div>
                            </td>
                            <td className="px-4 py-3">
                              <div className="flex justify-center">
                                <button
                                  type="button"
                                  onClick={() => {
                                    const updated = watch(`basePort.${item}`).filter(
                                      (_, i) => i !== index
                                    );

                                    setValue(`basePort.${item}`, updated);
                                  }}
                                  className="text-[#000] border-none bg-transparent"
                                >
                                  ✕
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
          })}
        </div>  
      </div>
      <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 mt-6 w-full lg:w-[90%] xl:w-[85%]">
        <button
          type="button"
          className="w-full sm:w-auto px-6 py-2.5 rounded-xl border-solid border-gray-300 bg-white text-gray-700 hover:bg-gray-50 active:scale-95 transition font-medium text-sm cursor-pointer"
          onClick={() => {
            fn.fn.fn.fn(false);
          }}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="w-full sm:w-auto px-6 py-2.5 rounded-xl bg-[#2F3E9E] text-white hover:bg-[#26358A] active:scale-95 transition font-medium text-sm shadow-sm cursor-pointer"
        >
          Save
        </button>
      </div>
  </form>
  );
  
}

